const styles = (theme) => ({
  root: {
    ...theme.mixins.modal.dialog.root,
  },
  helpertext: {
    color: theme.palette.alert.main,
  },
  fileTypeGridNew: {
    marginTop: '25px',
  },
  fileTypeGrid: {
    marginTop: '5px',
  },
});
export default styles;
